import minhImage from "../../public/minh1.png";

function ArticleHeaderDesktop({
  date,
  thumbnail,
  title,
  description,
  linkedinPost,
  githubRepo,
  youtube,
  note,
}: any) {
  return (
    <div className="flex flex-col gap-20 mt-12">
      <div>
        <div className="flex flex-col gap-8">
          <div className="flex  flex-col gap-2 text-pretty">
            <p className="text-[28px]  mb-2 font-bold leading-tight tracking-wide">
              {title}
            </p>
            {note && (
              <p className="text-[17px]  text-custom-green mb-4">{note}</p>
            )}
            {description && (
              <p className="text-gray-6 text-[17px] max-w-[700px]">
                {description}
              </p>
            )}
          </div>

          <div className="flex max-w-none items-center gap-4 mb-4">
            <div className="relative inline-flex select-none items-center justify-center overflow-hidden rounded-full align-middle font-medium uppercase text-primary h-10 w-10 bg-tertiary text-sm">
              <img
                loading="lazy"
                decoding="async"
                sizes="80px"
                style={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  inset: "0px",
                  color: "transparent",
                }}
                alt="minh"
                src={minhImage}
              />
            </div>
            <div className="leading-tight">
              <p className="text-[18px] font-normal mb-1">Minh Le</p>
              <div className="flex flex-row items-center">
                <p className="text-gray-6 ">
                  <time>{date}</time>
                </p>
                <div className="ml-4 flex flex-row underline underline-offset-4 text-gray-6 text-[16px]">
                  {githubRepo && (
                    <a className="mr-4" href={githubRepo} target="_blank">
                      Github Repo
                    </a>
                  )}
                  {linkedinPost && (
                    <a href={linkedinPost} target="_blank">
                      Linkedin Post
                    </a>
                  )}
                  {youtube && (
                    <a className="mr-4" href={youtube} target="_blank">
                      Youtube Demo
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="h-4"></div>
        <img
          alt="thumbnail"
          fetchPriority="high"
          decoding="async"
          data-nimg="1"
          className="md:rounded-lg -ml-4 lg:w-[calc(80%+100px)] 2xl:w-[calc(80%+160px)] w-[calc(100%+48px)] max-w-none"
          style={{ color: "transparent" }}
          src={thumbnail}
        ></img>
      </div>
    </div>
  );
}

export default ArticleHeaderDesktop;
